// Registers the push service worker (public/service-worker.js) at the app root scope.
// Push-only SW — no offline caching. Safe no-op on browsers without service workers.

const SW_URL = `${process.env.PUBLIC_URL || ""}/service-worker.js`;
const SW_SCOPE = `${process.env.PUBLIC_URL || ""}/`;

export const registerServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) {
    return Promise.resolve(null);
  }
  try {
    return await navigator.serviceWorker
      // updateViaCache: "none" — always revalidate the SW script itself, so a new deploy's
      // service worker is picked up instead of a stale HTTP-cached copy.
      .register(SW_URL, { scope: SW_SCOPE, updateViaCache: "none" });
  } catch (error) {
    console.error("Service worker registration failed:", error);
    return null;
  }
};
